import userActions from '../../actions';

const preferences = (state = [], action) => {
  switch (action.type) {
    case userActions.GET_USER_PREFERENCES_SUCCESS:
      return [...action.preferences];
    case userActions.SELECT_USER_PREFERENCES:
      if (state.includes(action.id)) {
        return state.filter((preferenceId) => preferenceId !== action.id);
      }
      return [...state, action.id];
    case userActions.LOGOUT_SUCCESS:
      return [];
    default:
      return state;
  }
};

export default preferences;
